<div
     class="s2 m-t-4 p-t-2-m p-b-2-m p-l-4-m p-r-4-m p-t-2-s p-b-2-s p-l-4-s p-r-4-s flex flex-justify-between flex-middle col-12">
    <product-social-share [model]="product" />
    <span class="block">Code: {{product.data.sku}}</span>
</div>